import React, { useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'

import { DialogContent, Button, Skeleton } from '@mui/material'

import { get } from 'utils/lodash'
import { handleError } from 'utils/error'
import { useLazyGetRentalFeesByConfiguredServiceQuery } from 'api/configured-service/configuredServiceRentalFeesCrud'

import T from 'T'
import HHBaseDialog from 'components/common/HHBaseDialog'
import HHDialogTitle from 'components/common/HHDialogTitle'
import HHDialogActions from 'components/common/HHDialogActions'
import UnbilledDaysChart from './UnbilledDaysChart'

const UnbilledDaysDialog = ({ isOpen = false, configuredServiceId, onClose }) => {
  const [getRentalFeesByConfiguredService, { isFetching: isGetRentalFeesByConfiguredServiceLoading, data: configuredRentalFeesData }] =
    useLazyGetRentalFeesByConfiguredServiceQuery()

  const rentalFeesByConfiguredService = useMemo(() => get(configuredRentalFeesData, 'configuredRentalFees', []), [configuredRentalFeesData])
  // Currently we support one rental fee per configured service
  const data = useMemo(() => get(rentalFeesByConfiguredService, '0', {}), [rentalFeesByConfiguredService])

  useEffect(() => {
    if (isOpen && configuredServiceId) {
      getRentalFeesByConfiguredService({ id: configuredServiceId }).unwrap().catch(handleError)
    }
  }, [isOpen, configuredServiceId])

  return (
    <HHBaseDialog open={isOpen} maxWidth="md" fullWidth onClose={onClose}>
      <HHDialogTitle title={T.UNBILLED_DAYS} onClose={onClose} />
      <DialogContent sx={{ p: 1 }}>
        {isGetRentalFeesByConfiguredServiceLoading && <Skeleton sx={{ mx: 2 }} variant="rectangular" height={120} />}
        {!isGetRentalFeesByConfiguredServiceLoading && <UnbilledDaysChart data={data} />}
      </DialogContent>
      <HHDialogActions>
        <Button size="small" variant="contained" color="primary" onClick={onClose}>
          {T.CLOSE}
        </Button>
      </HHDialogActions>
    </HHBaseDialog>
  )
}

UnbilledDaysDialog.propTypes = {
  isOpen: PropTypes.bool,
  configuredServiceId: PropTypes.string,
  onClose: PropTypes.func.isRequired,
}

export default UnbilledDaysDialog
